module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Upcoming Scheduled Social Posts")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.handleNewPost
    }
  }, [_vm._v("New Post")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.posts.length !== 0) ? _c('span', _vm._l((_vm.orderedPosts), function(post) {
    return _c('scheduled-post', {
      key: post.id,
      attrs: {
        "post": post,
        "channels": _vm.channels
      },
      on: {
        "edit": _vm.onEditPost,
        "delete": _vm.onDeletePost
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.posts.length) ? _c('p', {
    staticClass: "posts-placeholder"
  }, [_vm._v("No Scheduled Posts")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-266982ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/ScheduledPostList.vue
// module id = 3187
// module chunks = 3